import { prokey_server } from '../prokey/prokey.axios';

const ocr_baseuri = process.env.REACT_APP_OCROD_BASEURI
  ? process.env.REACT_APP_OCROD_BASEURI
  : window.location.origin;
const ocr_testuri = ocr_baseuri + '/api/Test';
const ocr_procuri = ocr_baseuri + '/api/ProcessBatch';
const ocr_getprocuri = ocr_baseuri + '/api/GetProcesses';
const ocr_sendTaskAsync = ocr_baseuri + '/api/SendTaskAsync';
const ocr_getTaskAsync = ocr_baseuri + '/api/GetTaskAsync';

class ocrOnDemandApi {
  static test() {
    fetch(ocr_testuri)
      .then((res) => {
        if (res.status >= 200 && res.status < 300) {
          return res.text();
        } else {
          let err = new Error(res.statusText);
          err.response = res;
          throw err;
        }
      })
      .then((data) => {
        console.log(data);
      })
      .catch((err) => {
        console.log('Error connecting to OCR On Demand Server');
        console.log(err);
      });
  }

  static async getProcs() {
    const ocrOdApiKey = (await prokey_server.getOcrOdApiKey()).data;
    return new Promise((resolve) => {
      fetch(ocr_getprocuri, {
        headers: {
          'Authorization': ocrOdApiKey,
        },
      })
        .then((res) => {
          if (res.status >= 200 && res.status < 300) {
            return res.text();
          } else {
            let err = new Error(res.statusText);
            err.response = res;
            throw err;
          }
        })
        .then((data) => {
          // Split the data into an array
          var procs = data.split('|');

          // Filter empty values
          procs = procs.filter((el) => el !== '');

          // Set the component data
          if (procs) resolve(procs);
          else resolve(null);
        })
        .catch((err) => {
          console.log('Error fetching processes');
          console.log(err);
          resolve(null);
        });
    });
  }

  static async process(fileInfo, app) {
    // define input verification 
    const not_safe = /[^a-zA-Z0-9 ._-]/g
    const safe_check = /^[a-zA-Z0-9 ._-]+/

    // cleanup unsafe characters
    const process_safe = fileInfo.process.replace(not_safe, '');
    const in_file_name_safe = fileInfo.inFileName.replace(not_safe, '');

    // final check that input is safe
    if (safe_check.test(process_safe) && safe_check.test(in_file_name_safe)) {
      const ocrOdApiKey = (await prokey_server.getOcrOdApiKey()).data;
      var formData = new FormData();
      formData.append(in_file_name_safe, fileInfo.inFile);

      fileInfo.status = 'Processing';
      app.forceUpdate();

      const header_data = {
        'host': ocr_baseuri,
        'Authorization': ocrOdApiKey,
        'encrypted': 'false',
        'process-name': process_safe,
      }

      fetch(ocr_procuri, { method: 'post', body: formData, headers: header_data }) // nosemgrep - issue resolved with input validation
        .then((res) => {
          if (res.status >= 200 && res.status < 300) {
            console.log('success');
            return res.text();
          } else {
            console.log('fail');
            fileInfo.status = 'Failed - ' + res.statusText;
            fileInfo.pctComplete = 100;
            app.forceUpdate();

            let err = new Error(res.statusText);
            err.response = res;
            throw err;
          }
        })
        .then((data) => {
          this.parseData(data, fileInfo);
          fileInfo.status = 'Complete';
          fileInfo.pctComplete = 100;
          app.forceUpdate();
        })
        .catch((err) => {
          console.log('Error sending file: ' + fileInfo.inFileName);
          console.log(err);

          fileInfo.status = 'Failed';
          fileInfo.pctComplete = 100;
          app.forceUpdate();
        });
    }
  }

  static async parseData(res, fileInfo) {
    try {
      var newFiles = [];
      let test = await res.text();
      test.split(/(--\w+[-]\w+[-]\w+[-]\w+[-]\w+)/g).forEach((match) => {
        if (match.includes('Content-Disposition:')) newFiles.push(match);
      });
      newFiles.forEach((newFile) => {
        var newFileObject = this.parseFile(newFile);
        // console.log('received file: ' + newFileObject.name);
        if (newFileObject !== null) {
          if (newFileObject.name.toLowerCase().includes('.res')) {
            fileInfo.outRes = newFileObject.contents;
          }
          if (newFileObject.name.toLowerCase().includes('.pdf')) {
            fileInfo.outPdf = new File([Buffer.from(newFileObject.contents, 'base64')], newFileObject.name);
          }
        } else console.log('File parsing failed!');
      });
    } catch (err) {
      console.log(err);
    }
  }

  static parseFile(newFile) {
    try {
      var fileObject = { name: '', contentType: '', contents: '' };
      var lines = newFile.split(/\r\n/g);
      lines.forEach((line) => {
        var parts = '';
        if (fileObject.contentType.length < 1 && line.includes('Content-Type:')) {
          parts = line.split(':');
          if (parts.length > 0) fileObject.contentType = parts[1];
        } else if (fileObject.name.length < 1 && line.includes('Content-Disposition:')) {
          parts = line.split(';');
          if (parts.length > 0) fileObject.name = parts[1].split('=')[1];
        }
      });
      lines.forEach((line) => {
        if (line && !line.includes('Content-Type:') && !line.includes('Content-Disposition:') && line !== '')
          fileObject.contents += line + '\r\n';
      });
      fileObject.contents = fileObject.contents.substring(0, fileObject.contents.length - 2);
    } catch (err) {
      console.log(err);
    }

    if (fileObject.name.length > 0 && fileObject.contentType.length > 0 && fileObject.contents.length > 0)
      return fileObject;
    else return null;
  }


  //#region async

  static async sendTaskAsync(fileInfo) {
    const ocrOdApiKey = (await prokey_server.getOcrOdApiKey()).data;

    var formData = new FormData();
    formData.append(fileInfo.inFileName, fileInfo.inFile);

    try {
      const response = fetch(ocr_sendTaskAsync, {
        method: 'post',
        body: formData,
        headers: {
          'Authorization': ocrOdApiKey,
          'encrypted': 'false',
          'process-name': fileInfo.process,
        },
      });

      return response;

    } catch (error) {
      console.log('Error sending file: ' + fileInfo.inFileName);
      console.log(error);

      return {
        status: 500
      };
    }
  }

  static async getTaskAsync(batch_id, process) {
    const ocrOdApiKey = (await prokey_server.getOcrOdApiKey()).data;

    // define input verification 
    const not_safe = /[^a-zA-Z0-9 ._-]/g
    const safe_check = /^[a-zA-Z0-9 ._-]+/

    // cleanup unsafe characters
    const batch_id_safe = batch_id.replace(not_safe, '');
    const process_safe = process.replace(not_safe, '');

    // final check that input is safe
    if(safe_check.test(batch_id_safe) && safe_check.test(process_safe)) {
      const header_data = {
        'host': ocr_baseuri,
        'Authorization': ocrOdApiKey,
        'encrypted': 'false',
        'batch-id': batch_id_safe,
        'process-name': process_safe,
      }

      try {
        const response = fetch(ocr_getTaskAsync, { method: 'post', headers: header_data }); // nosemgrep - issue resolved with input validation
        return response;
      } catch (error) {
        console.log(`Error retrieving task info: ${batch_id_safe}`);
        console.log(error);

        return {
          status: 500
        };
      }
    }
  }
  //#endregion
}

export default ocrOnDemandApi;
